import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <>
      {/* Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap"
        rel="stylesheet"
      />

      <style>{`
        * {
          font-family: 'Open Sans', sans-serif;
          box-sizing: border-box;
        }

        .footer {
          background-color: #111;
          color: #f0f0f0;
          padding: 20px 10px 10px;
        }

        .footer-container {
          width: 80%;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 40px;
        }

        .footer-section {
          flex: 0 0 auto;
          width: fit-content;
          margin-bottom: 0px;
          text-align: left;
        }

        .footer-logo {
          width: 120px;
          margin-bottom: 20px;
        }

        .footer-title {
          font-size: 16px;
          font-weight: 650;
          margin-bottom: 10px;
        }

        .footer-description {
          font-size: 14px;
          color: #ccc;
          line-height: 1.6;
        }

        .footer-heading {
          color: #d4af37;
          font-weight: 600;
          margin-bottom: 15px;
          font-size: 18px;
          font-family: 'Playfair Display', serif;
          text-align: left;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 10px;
          text-align: left;
        }

        .footer-links a {
          color: #fff;
          text-decoration: none;
          font-size: 14px;
          transition: text-decoration 0.3s ease;
        }

        .footer-links a:hover {
          text-decoration: underline;
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 22px;
          margin-bottom: 0px;
        }

        .icon-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #111;
          font-size: 16px;
          flex-shrink: 0;
          transition: transform 0.2s;
          margin-top: 25px;
        }

        .icon-circle:hover {
          transform: scale(1.1);
        }

        .contact-info-label {
          font-weight: bold;
          color: #fff;
          font-size: 15px;
          margin-bottom: 0px;
        }

        .contact-info {
          font-size: 14px;
          color: #ccc;
          line-height: 1.4;
        }

        .footer-bottom {
          text-align: center;
          padding-top: 20px;
          padding-bottom: 15px;
          margin-top: 20px;
          border-top: 1px solid #333;
        }

        .footer-bottom-container {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 40px; /* Increased spacing */
          color: #aaa;
          font-size: 13px;
          margin: 10px;
          text-align: center;
        }

        .footer-bottom-links {
          display: flex;
          gap: 20px; /* Gap between links */
        }

        .footer-bottom-links a {
          color: #ddd;
          text-decoration: none;
          font-size: 14px;
          margin: 0 5px;
          transition: color 0.3s ease;
        }

        .footer-bottom-links a:hover {
          color: #fff;
          text-decoration: underline;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .footer {
            padding: 40px 15px 15px;
          }

          .footer-container {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 25px;
            width: 95%;
          }

          .footer-section {
            width: 100%;
            padding-bottom: 15px;
            border-bottom: 1px solid #222;
            text-align: center;
          }

          .footer-section:last-of-type {
            border-bottom: none;
            padding-bottom: 0;
          }

          .footer-logo {
            margin: 0 auto 15px;
          }

          .footer-description {
            font-size: 13px;
            max-width: 100% !important;
          }

          .footer-heading,
          .footer-title,
          .contact-info-label,
          .contact-info {
            text-align: center !important;
          }

          .footer-links {
            margin: 0 auto;
            text-align: center;
          }

          .footer-links li {
            margin: 0 auto 10px;
            text-align: center;
          }

          .contact-item {
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 15px;
          }

          .contact-item .icon-circle {
            margin-bottom: 0px;
            margin-top: 0;
          }

          .footer-bottom-container {
            flex-direction: column;
            align-items: center;
            gap: 10px;
            text-align: center;
          }

          .footer-bottom-links {
            justify-content: center;
            flex-wrap: wrap;
          }
        }

        @media (max-width: 480px) {
          .footer {
            padding: 10px 10px 0px;
          }

          .footer-logo {
            width: 100px;
          }

          .footer-title {
            font-size: 15px;
          }

          .footer-description {
            font-size: 12px;
          }

          .footer-heading {
            font-size: 15px;
          }

          .icon-circle {
            width: 35px;
            height: 35px;
            font-size: 14px;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">
          {/* Left: Logo & Description */}
          <div className="footer-section">
            <img src={logo} alt="Logo" className="footer-logo" />
            <h3 className="footer-title">The Porch Cafe & Restaurant</h3>
            <p className="footer-description" style={{ maxWidth: '300px' }}>
              Where Great Taste Meets Warm Hospitality. From Aromatic Coffees To Deliciously Crafted Meals, We Serve Comfort, Flavor, And A Cozy Atmosphere—All In One Place. Join Us For Good Food, Great Conversations, And Unforgettable Moments.
            </p>
          </div>

          {/* Center: Links */}
          <div className="footer-section center">
            <h4 className="footer-heading">Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="#about-us">About Us</a></li>
              <li><a href="/menu">Menu</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>

          {/* Right: Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Get In Touch</h4>

            <div className="contact-item">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=The+Porch+Cafe,+Hotel+The+Pride,+Kota"
                target="_blank"
                rel="noopener noreferrer"
                className="icon-circle"
              >
                <FaMapMarkerAlt />
              </a>
              <div>
                <p className="contact-info-label">Location</p>
                <p className="contact-info">
                  Rooftop Area, Hotel The Pride, 267,<br />
                  Rajeev Gandhi Nagar, Kota (324005)
                </p>
              </div>
            </div>

            <div className="contact-item">
              <a href="tel:+919024283004" className="icon-circle">
                <FaPhoneAlt />
              </a>
              <div>
                <p className="contact-info-label">Phone Number</p>
                <p className="contact-info">
                  +91 902 428 3004<br />
                  +91 960 267 9997
                </p>
              </div>
            </div>

            <div className="contact-item">
              <a href="mailto:info@theporchcafe.in" className="icon-circle">
                <FaEnvelope />
              </a>
              <div>
                <p className="contact-info-label">Email Address</p>
                <p className="contact-info">info@theporchcafe.in</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-container">
            <span>© 2025 The Porch Cafe & Restaurant</span>
            <div className="footer-bottom-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-use">Terms of Use</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
